var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.550758,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#EEEAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2352 11.2871L15.4606 14.0617L18.2814 16.8825L17.3565 17.8074L14.5357 14.9865L11.7611 17.7611L10.8208 16.8208L13.5954 14.0462L10.7746 11.2254L11.6995 10.3005L14.5203 13.1214L17.2949 10.3468L18.2352 11.2871Z",
    fill: "#714fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearLocation);
export default __webpack_public_path__ + "static/media/clear-location.b8e4a4e44066fba658ebb811bf7bd6f7.svg";
export { ForwardRef as ReactComponent };